import { useEffect, useState } from "react";
import { currencyFormat, dateFormatYMD, toWords } from "src/utils/helperFunction";
import { FeeTypes, PayementModeType, ReceiptPaymentLabel } from "src/utils/constants/constant";
import { ReceiptLogo as TopBarLogoTwo } from "./ReceiptLogo";
import { AuthorizedSignature } from "./AuthorizedSignature";
import { IStudentInvoice } from "src/services/feesDetails/fees.model";
import { IStudentList } from "src/services/student/student.model";

interface ExactReceiptProps {
  invoiceData: IStudentInvoice | null | undefined;
  admissionData: IStudentList | undefined;
  label: string;
}

const ExactReceiptWithOutGst = ({ invoiceData, admissionData, label }: ExactReceiptProps) => {
  const [receiptType, setReceiptType] = useState<string>();
  const [isChequeType, setIsChequeType] = useState<boolean>(false);
  useEffect(() => {
    if (invoiceData?.payment_mode === PayementModeType.CASH) {
      setReceiptType(ReceiptPaymentLabel.CASH);
      setIsChequeType(false);
    } else if (
      invoiceData?.payment_mode === PayementModeType.CHEQUE ||
      invoiceData?.payment_mode === PayementModeType.DD ||
      invoiceData?.payment_mode === PayementModeType.NEFT_IMPS
    ) {
      setReceiptType(ReceiptPaymentLabel.CHEQUE);
      setIsChequeType(true);
    } else {
      setIsChequeType(false);
      setReceiptType(ReceiptPaymentLabel.ONLINE);
    }
  }, [invoiceData]);

  const isPenalty = (invoiceData?.admission_penalty?.length ?? 0) > 0;
  const feesTotal =
    invoiceData?.invoice_fees?.reduce(
      (sum, fee) => sum + Number(fee?.amount ?? 0),
      0,
    ) ?? 0;

  const totalPaid = isPenalty ? Number(invoiceData?.payAmount ?? 0) : feesTotal;
  return (
    <>
      <table className="student-receipt-table student-receipt-table-without-gst">
        <tbody>
          <tr>
            <td>
              {/* <Temporary Code Comment> */}
              {/* <ReceiptLogo invoiceDate={invoiceData?.invoiceDate} /> */}
            </td>
          </tr>
        </tbody>
        <tbody className={"receipt-content-padding"}>
          <tr>
            <td>
              <table
                className={"gx-w-100" + (invoiceData?.branch?.registered_office_address ? "" : " receipt-border-bottom")}
              >
                <tbody
                  className={"gx-d-flex gx-align-items-center"}
                >
                  <TopBarLogoTwo invoiceData={invoiceData} />
                  <tr className={"receipt-width-20 gx-text-center"}>
                    <td
                      className={"receipt-font-heading gx-d-inline-block receipt-font-bold receipt-title-padding"}
                    >
                      Receipt
                    </td>
                  </tr>
                  <tr className={"receipt-width-40 gx-text-right"}>
                    <td
                      className={"receipt-font-large receipt-font-bold receipt-branch-title-spacing"}
                    >
                      {invoiceData?.branch_name !== null ? invoiceData?.branch_name : invoiceData?.branch?.title}
                    </td>
                    <td>
                      <b>Branch Address</b> :{" "}
                      {invoiceData?.address || invoiceData?.branch?.address || "-"}
                    </td>
                    <td>
                      Mobile No :&nbsp;
                      {invoiceData?.branch?.mobile_one ||
                        invoiceData?.branch?.landline_no}
                    </td>
                  </tr>
                </tbody>
              </table>
              {invoiceData?.branch?.registered_office_address ? (
                <table
                  className={"gx-w-100"}
                >
                  <tbody>
                    <tr>
                      <td
                        className={"receipt-border-bottom receipt-address-padding receipt-wrap-text receipt-break-word"}
                      >
                        <b>Registered Office Address</b> :{" "}
                        {invoiceData.branch.registered_office_address}
                      </td>
                    </tr>
                  </tbody>
                </table>
              ) : null}
              <table
                className={"gx-d-block receipt-section-padding"}
              >
                <tbody
                  className={"gx-d-flex gx-justify-content-between receipt-align-baseline"}
                >
                  <tr className={"receipt-width-43"}>
                    <td>
                      <b>Receipt No :</b>&nbsp; {invoiceData?.invoiceNo}
                    </td>
                    <td>
                      <b>Enrollment No :&nbsp;</b>{" "}
                      {invoiceData?.admission?.enrollment_number}
                    </td>
                    <td
                      className={"gx-text-capitalize"}
                    >
                      <b>Student Name :&nbsp;</b>
                      {invoiceData?.admission?.first_name +
                        " " +
                        invoiceData?.admission?.middle_name +
                        " " +
                        invoiceData?.admission?.last_name}
                    </td>
                  </tr>
                  <tr className={"receipt-width-42"}>
                    <td>
                      <b>GR Id :&nbsp;</b> {invoiceData?.admission?.gr_id}
                    </td>
                    <td>
                      <b>{label}&nbsp;Name</b> :&nbsp;
                      {admissionData && admissionData?.package?.name
                        ? admissionData?.package?.name
                        : admissionData?.admission_subcourses
                            ?.map((admissionSubcourse) => admissionSubcourse.subcourse?.name)
                            .join(", ")}
                    </td>
                  </tr>
                  <tr className={"gx-text-right receipt-width-15"}>
                    <td className={"gx-text-nowrap"}>
                      <b>Date :&nbsp;</b>
                      {dateFormatYMD(invoiceData?.pay_date, "D MMM YY")}
                    </td>
                    <td className={"gx-text-nowrap"}>
                      <b>SAC :&nbsp;</b> 9992
                    </td>
                  </tr>
                </tbody>
              </table>

              <div>
                <table
                  className={"gx-w-100 receipt-border"}
                  border={0}
                  cellPadding={8}
                  cellSpacing={0}
                >
                  <thead>
                    <tr className={"gx-d-flex"}>
                      <th
                        className={"receipt-border-right receipt-border-bottom gx-w-50 gx-text-center"}
                      >
                        Fees Type
                      </th>
                      <th
                        className={"receipt-border-bottom gx-w-50 gx-text-center"}
                      >
                        Fees Paid
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {invoiceData?.invoice_fees &&
                        invoiceData?.invoice_fees?.map((fees) => (
                          <>
                            {(Number(fees?.amount) > 0 ||
                              fees.fee_type?.name === FeeTypes.TUITION) && (
                              <tr className={"gx-d-flex"}>
                                <td
                                  className={"receipt-border-right receipt-border-bottom gx-w-50 gx-text-center"}
                                >
                                  {fees?.fee_type?.name}
                                </td>
                                <td
                                  className={"receipt-border-bottom gx-w-50 gx-text-center"}
                                >
                                  <span>&#8377;</span>
                                  {currencyFormat(
                                    Math.trunc(Number(fees?.amount)),
                                  )}
                                </td>
                              </tr>
                            )}
                          </>
                        ))}
                      {invoiceData && isPenalty && (
                        <tr className={"gx-d-flex"}>
                          <td
                            className={"receipt-border-right receipt-border-bottom gx-w-50 gx-text-center"}
                          >
                            {invoiceData?.admission_penalty?.[0]?.incomeType?.name ?? ""}
                          </td>
                          <td
                            className={"receipt-border-bottom gx-w-50 gx-text-center"}
                          >
                            <span>&#8377;</span>
                            {currencyFormat(
                              Math.trunc(Number(invoiceData?.payAmount)),
                            )}
                          </td>
                        </tr>
                      )}
                    </>
                  </tbody>
                  <tfoot>
                    <tr className={"gx-d-flex"}>
                      <td
                        className={"receipt-border-right gx-w-50 gx-text-center receipt-font-bold"}
                      >
                        Total
                      </td>

                      <td
                        className={"gx-w-50 gx-text-center"}
                      >
                        <span>&#8377;</span>
                        {currencyFormat(Math.trunc(totalPaid))}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <table
                className={"gx-w-100 receipt-auto-height receipt-section-padding gx-d-block"}
              >
                <thead
                  className={"gx-d-flex gx-justify-content-between"}
                >
                  {isChequeType === true ? (
                    <tr className={"receipt-width-65"}>
                      <td>
                        <b>Payment Mode :&nbsp;</b> {receiptType}
                        &nbsp;Payment
                      </td>
                      <td>
                        <b>Name :&nbsp;</b>
                        {invoiceData?.cheque_holder_name}
                        <br />
                        <b>Cheque No</b> :&nbsp;
                        {invoiceData?.cheque_no},&nbsp;
                        <br />
                        <b>Cheque Date</b>
                        :&nbsp;
                        {dateFormatYMD(invoiceData?.cheque_date, "DD-MM-YYYY")}
                        <br />
                        <b>Bank Name</b> :&nbsp;
                        {invoiceData?.bank_name}, (
                        {invoiceData?.bank_branch_name})
                      </td>
                    </tr>
                  ) : (
                    <tbody>
                      <tr>
                        <td>
                          <b>Payment Mode :&nbsp;</b> {receiptType} Payment
                        </td>
                      </tr>

                      {invoiceData?.payment_mode === PayementModeType.ONLINE_PAYMENT && (
                        <>
                          {invoiceData?.transaction_no && (
                            <tr>
                              <td>
                                <b>Transaction ID :&nbsp;</b>{" "}
                                {invoiceData.transaction_no}
                              </td>
                            </tr>
                          )}
                          {invoiceData?.transaction_date && (
                            <tr>
                              <td>
                                <b>Transaction Date :&nbsp;</b>{" "}
                                {dateFormatYMD(invoiceData.transaction_date, "DD-MM-YYYY")}
                              </td>
                            </tr>
                          )}
                        </>
                      )}
                    </tbody>
                  )}
                  <tr className={"receipt-width-35"}>
                    <td
                      className={"gx-text-right gx-text-capitalize"}
                    >
                      <b>The Sum of :&nbsp;</b>
                      {invoiceData?.invoice_fees &&
                        toWords.convert(
                          feesTotal,
                        )}
                    </td>
                  </tr>
                </thead>
              </table>
              <table
                className={"gx-w-100 gx-d-flex gx-align-items-end receipt-terms-padding"}
              >
                <tbody
                  className={"gx-w-75 receipt-font-small receipt-line-readable receipt-word-spacing"}
                >
                  <tr>
                    <td>
                      <b>T&C&nbsp;</b>:&nbsp;This invoice generated for
                      educational services payment.
                    </td>
                    <td>
                      *Fees will be not refundable.
                    </td>
                    <td>
                      GST exempted as per Notification 12/2017, Entry 69
                      (NSDC-approved training).
                    </td>
                    <td>
                      <b>Note:</b>&nbsp;This&nbsp;is&nbsp;a&nbsp;digitally&nbsp;generated&nbsp;receipt.
                    </td>
                    {invoiceData?.admission_installments?.remarks ? (
                      <p>
                        <b>Remarks&nbsp;</b>:&nbsp;
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              invoiceData?.admission_installments?.remarks,
                          }}
                        />
                      </p>
                    ) : (
                      ""
                    )}
                  </tr>
                </tbody>
                <tbody className={"gx-w-25 gx-text-center"}>
                  <tr>
                    <td>
                      <AuthorizedSignature />
                    </td>
                    <td
                      className={"receipt-line-compact gx-font-weight-medium"}
                    >
                      ------------------------
                    </td>
                    <td className={"gx-font-weight-medium"}>
                      Authorized By
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default ExactReceiptWithOutGst;
